module.exports = __webpack_public_path__ + "img/certificateFace.1006528.jpg";